import React from 'react'
import { DomainNotificationBuilderView } from '../../../components/notification-builder/views/domain-notification-builder-view'

export const SendNotification = () => {
    return <DomainNotificationBuilderView formMode="create" />
}
